import { render, staticRenderFns } from "./warn-info.vue?vue&type=template&id=41ab2ca3&scoped=true"
import script from "./warn-info.vue?vue&type=script&lang=js"
export * from "./warn-info.vue?vue&type=script&lang=js"
import style0 from "./warn-info.vue?vue&type=style&index=0&id=41ab2ca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ab2ca3",
  null
  
)

export default component.exports